import { Text as e } from "../../Typography/Typography.js";
import "../../Typography/index.js";
import "../../../config/globalConstants.js";
import { useOverflowTooltip as t } from "../../../hooks/useOverflowTooltip.js";
import "../../../hooks/index.js";
import { HighlightSearch as ee } from "../../HighlightSearch/HighlightSearch.js";
import { getLeafNodeIds as te, hasChildren as n } from "../helpers/selectionProcessing.js";
import { insertSpacesInStr as ne } from "../../../utils/string.js";
import r from "./TreeNodeHeader.module.js";
import { c as re } from "react/compiler-runtime";
import { Button as ie } from "@jetbrains/ring-ui-built/components/button/button";
import ae from "classnames";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import oe from "@jetbrains/ring-ui-built/components/tooltip/tooltip";
import { H4 as se } from "@jetbrains/ring-ui-built/components/heading/heading";
import ce from "@jetbrains/icons/chevron-down";
import o from "@jetbrains/icons/chevron-right";
import s from "@jetbrains/ring-ui-built/components/checkbox/checkbox";
//#region src/components/Tree/TreeNodeHeader/TreeNodeHeader.tsx
var c = (c) => {
	let l = re(64), { node: u, isExpanded: d, selection: f, onExpandToggle: p, onSelect: m, search: h } = c, [g, _] = t(), v;
	l[0] === u ? v = l[1] : (v = n(u), l[0] = u, l[1] = v);
	let y = v, b = y || !!u.helpTextElement, { id: x, collapsible: S, selectable: C, titleClassName: w, titleSuffixElement: T, optionsCount: E, title: D } = u, O;
	l[2] !== y || l[3] !== x || l[4] !== f ? (O = !y && f.has(x), l[2] = y, l[3] = x, l[4] = f, l[5] = O) : O = l[5];
	let k = O, A, j;
	l[6] !== y || l[7] !== u || l[8] !== f ? (A = y ? Array.from(te([u])) : [], j = A.filter((e) => f.has(e)), l[6] = y, l[7] = u, l[8] = f, l[9] = A, l[10] = j) : (A = l[9], j = l[10]);
	let M = j.length, N = A.length > 0 && M === A.length, P = M > 0 && M < A.length, F;
	l[11] !== u || l[12] !== m ? (F = (e) => {
		m(u, e.target.checked);
	}, l[11] = u, l[12] = m, l[13] = F) : F = l[13];
	let I = F, L;
	l[14] !== u || l[15] !== p ? (L = () => {
		p(u);
	}, l[14] = u, l[15] = p, l[16] = L) : L = l[16];
	let R = L, z;
	l[17] !== h || l[18] !== D ? (z = /* @__PURE__ */ i(ee, {
		search: h,
		line: D
	}), l[17] = h, l[18] = D, l[19] = z) : z = l[19];
	let B = z, V = B;
	if (u.titleType === "heading") {
		let e;
		l[20] === B ? e = l[21] : (e = /* @__PURE__ */ i(se, {
			className: r.heading,
			children: B
		}), l[20] = B, l[21] = e), V = e;
	} else if (u.titleType === "semibold") {
		let t;
		l[22] === B ? t = l[23] : (t = /* @__PURE__ */ i(e, {
			semibold: !0,
			children: B
		}), l[22] = B, l[23] = t), V = t;
	}
	let H = `tree-node-${x}`, U;
	l[24] !== S || l[25] !== R || l[26] !== b || l[27] !== d || l[28] !== x || l[29] !== D ? (U = S && b ? /* @__PURE__ */ i(ie, {
		"aria-expanded": d,
		"aria-label": `${d ? "Collapse" : "Expand"} "${D}"`,
		"data-test": `expand-button-${x}`,
		className: r.expandButton,
		icon: d ? ce : o,
		onClick: R
	}) : /* @__PURE__ */ i("div", { className: r.buttonPlaceholder }), l[24] = S, l[25] = R, l[26] = b, l[27] = d, l[28] = x, l[29] = D, l[30] = U) : U = l[30];
	let W;
	l[31] !== N || l[32] !== I || l[33] !== k || l[34] !== y || l[35] !== x || l[36] !== C || l[37] !== P || l[38] !== D ? (W = C && /* @__PURE__ */ i(s, {
		"aria-label": y ? D : `${D} (${x})`,
		indeterminate: P,
		checked: k || N,
		onChange: I,
		"data-test": `checkbox-${x}`
	}), l[31] = N, l[32] = I, l[33] = k, l[34] = y, l[35] = x, l[36] = C, l[37] = P, l[38] = D, l[39] = W) : W = l[39];
	let G;
	l[40] === w ? G = l[41] : (G = ae(r.labelContainer, w), l[40] = w, l[41] = G);
	let K = _ ? D : void 0, q;
	l[42] !== V || l[43] !== g ? (q = /* @__PURE__ */ i("div", {
		ref: g,
		className: r.title,
		children: V
	}), l[42] = V, l[43] = g, l[44] = q) : q = l[44];
	let J;
	l[45] !== K || l[46] !== q ? (J = /* @__PURE__ */ i(oe, {
		title: K,
		delay: 800,
		className: r.tooltip,
		children: q
	}), l[45] = K, l[46] = q, l[47] = J) : J = l[47];
	let Y;
	l[48] !== S || l[49] !== E ? (Y = S && E > 0 && /* @__PURE__ */ i(e, {
		secondary: !0,
		children: ne(E.toString())
	}), l[48] = S, l[49] = E, l[50] = Y) : Y = l[50];
	let X;
	l[51] !== J || l[52] !== Y || l[53] !== G || l[54] !== T ? (X = /* @__PURE__ */ a("div", {
		className: G,
		children: [
			J,
			T,
			Y
		]
	}), l[51] = J, l[52] = Y, l[53] = G, l[54] = T, l[55] = X) : X = l[55];
	let Z = (!S || y || d) && u.helpTextElement, Q;
	l[56] !== X || l[57] !== Z ? (Q = /* @__PURE__ */ a("div", {
		className: r.container,
		children: [X, Z]
	}), l[56] = X, l[57] = Z, l[58] = Q) : Q = l[58];
	let $;
	return l[59] !== Q || l[60] !== H || l[61] !== U || l[62] !== W ? ($ = /* @__PURE__ */ a("div", {
		className: r.nodeContent,
		"data-test": H,
		children: [
			U,
			W,
			Q
		]
	}), l[59] = Q, l[60] = H, l[61] = U, l[62] = W, l[63] = $) : $ = l[63], $;
};
//#endregion
export { c as TreeNodeHeader };
